module.exports.data = [
  {
    id: 1,
    projectTitle: `Xavi's music lounge`,
    gifSource: "media/MusicLounge.webp",
    link: `https://legendary-tartufo-7b1cd1.netlify.app/register`,
    projectDescription: [
      {
        id: 1,
        data: `A minimalistic Spotify UI with the ability to search for your favorite
    artists, listen to songs, and save the songs to your own curated
    playlist.`,
      },

      {
        id: 2,
        data: `Created with Angular and Node, this app has integrations with
    PassportJWT, MongoDB and Spotify's public API.`,
      },
    ],
  },
  {
    id: 2,
    projectTitle: `Portfolio`,
    gifSource: "media/portfolio.webp",
    link: `https://xavier-alejandro.com/`,
    projectDescription: [
      {
        id: 1,
        data: `My portfolio.`,
      },

      {
        id: 2,
        data: `Created with React.`,
      },
    ],
  },
  {
    id: 3,
    projectTitle: `Room of Chat`,
    gifSource: "media/RoomOfChat.webp",
    link: `https://spontaneous-manatee-291ab8.netlify.app/`,
    projectDescription: [
      {
        id: 1,
        data: `Spark a conversation with someone from across the world. Whether it be anonymously or as yourself.`,
      },

      {
        id: 2,
        data: `Created with Angular and Node, this app integrates Socket.io to cross communicate between clients.`,
      },
    ],
  },
];
